import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import { Icon, Menu } from '@icp/components';
import { isIndex } from '@icp/utils';
import { useEvents, useReadonly, useWorkflowTypeNodeMap } from './NodeContextProvider';
import { makeNewNode } from './utils';

function AddNodeButton(props) {
  const { keyPath } = props;

  const workflowTypeNodeMap = useWorkflowTypeNodeMap();
  const { onAddNode } = useEvents();
  const readonly = useReadonly();

  const [buttonEl, setButtonEl] = useState(null);

  const nodeListOptions = useMemo(() => {
    return Object.keys(workflowTypeNodeMap).map((token) => {
      const nodeType = workflowTypeNodeMap[token];
      return {
        key: token,
        icon: nodeType.icon,
        label: nodeType.name,
      };
    });
  }, [workflowTypeNodeMap]);

  const handleAdd = (item) => {
    const newNode = makeNewNode(item.key, workflowTypeNodeMap);
    const index = keyPath[keyPath.length - 1];
    const insertKeyPath = isIndex(index)
      ? keyPath.slice(0, -1).concat(index + 1)
      : keyPath.concat(0);
    onAddNode(insertKeyPath, newNode);
  };

  if (readonly) {
    return null;
  }

  return (
    <>
      <button
        className="icp-workflow-add-button icp-action-button"
        onClick={(event) => setButtonEl(event.currentTarget)}
      >
        <Icon name="material:add-rounded" size={16} />
      </button>
      <Menu
        open={!!buttonEl}
        anchorEl={buttonEl}
        items={nodeListOptions}
        onClick={handleAdd}
        onClose={() => setButtonEl(null)}
      />
    </>
  );
}

AddNodeButton.propTypes = {
  keyPath: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
};

export default AddNodeButton;
